var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.028,
    height: 19.769,
    viewBox: "0 0 21.028 19.769",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-star",
    "data-name": "Icon awesome-star",
    d: "M10.368.651,7.927,5.5l-5.462.78a1.166,1.166,0,0,0-.662,2L5.755,12.05l-.935,5.328a1.191,1.191,0,0,0,1.735,1.234L11.441,16.1l4.886,2.516a1.192,1.192,0,0,0,1.735-1.234l-.935-5.328,3.951-3.772a1.166,1.166,0,0,0-.662-2L14.955,5.5,12.514.651a1.209,1.209,0,0,0-2.146,0Z",
    transform: "translate(-0.927 0.501)",
    fill: "#fff",
    stroke: "#d0cfd6",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarEmpty);
export default __webpack_public_path__ + "static/media/star-empty.b6347168cbcf4ea37e5966aa511252ce.svg";
export { ForwardRef as ReactComponent };